import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "row no-gutters" };
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = {
    key: 0,
    class: "warrantyPatch",
    alt: "36 Monate Garantie",
    src: "/images/_new_brand/product_detail_page/36_monate_garantie.png",
    style: { "width": "80px", "max-width": "30%", "position": "absolute", "left": "-3%", "bottom": "8%", "z-index": "3", "object-fit": "contain" }
};
const _hoisted_4 = { class: "carousel__item__gallery" };
const _hoisted_5 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_slide = _resolveComponent("slide");
    const _component_pagination = _resolveComponent("pagination");
    const _component_Carousel = _resolveComponent("Carousel");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (((_a = _ctx.currentProduct) === null || _a === void 0 ? void 0 : _a.hasExtendedWarrantyMonth) === 36)
                ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                : _createCommentVNode("", true),
            _createVNode(_component_Carousel, {
                "items-to-show": 1,
                "wrap-around": true,
                modelValue: _ctx.currentSlide,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.currentSlide) = $event))
            }, {
                addons: _withCtx(() => [
                    _createVNode(_component_pagination)
                ]),
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allImages, (src, index) => {
                        return (_openBlock(), _createBlock(_component_slide, { key: index }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("img", {
                                        onClick: _cache[0] || (_cache[0] =
                                            //@ts-ignore
                                            (...args) => (_ctx.triggerFancyBox && _ctx.triggerFancyBox(...args))),
                                        src: _ctx.optimizeImage(src, 400),
                                        class: "bigGalleryImageMobile",
                                        alt: "Produktbild"
                                    }, null, 8, _hoisted_5)
                                ])
                            ]),
                            _: 2
                        }, 1024));
                    }), 128))
                ]),
                _: 1
            }, 8, ["modelValue"])
        ])
    ]));
}
